import PolarisAssistantAPI from 'dashboard/api/polaris/assistant';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'PolarisAssistant',
  API: PolarisAssistantAPI,
});
